export default {
    API_ENDPOINT: `https://safe-refuge-61508.herokuapp.com`,
    TOKEN_KEY: 'gearboard-client-auth-token',
}